import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';

import { ARTWORK_BAG_STATUS } from '@components/PDP/artworkSidebar/artworkSidebar.constants';
import { ADD_TO_BAG_TEST_ID, ADD_TO_BAG_LOADING_TEST_ID } from '@components/addToBag/addToBag.constants';
import { LoadingOverlay } from '@components/loadingOverlay';
import { LOADING_OVERLAY_VARIANT } from '@components/loadingOverlay/loadingOverlay.component';
import { QuantitySelect } from '@components/PDP/artworkDetails/quantitySelect';
import { renderWhenTrue, renderWhenTrueOtherwise } from '@utils/rendering';
import { formatStorePrice } from '@utils/helpers';

import { Text, Price, InnerContainer, OuterContainer } from './addToBagWithQuantitySelect.styles';

export interface AddToBagWithQuantitySelectProps {
  onClick: (quantity: number) => void;
  status: ARTWORK_BAG_STATUS;
  price: number;
  inventoryLevel: number;
  isVariant: boolean;
  options: number[];
}

export const AddToBagWithQuantitySelect = ({
  onClick,
  status,
  price,
  inventoryLevel,
  isVariant,
  options,
}: AddToBagWithQuantitySelectProps) => {
  const [selectedQuantity, setSelectedQuantity] = useState(1);
  const isAddedToBag = status === ARTWORK_BAG_STATUS.ADDED;
  const isLoading = status === ARTWORK_BAG_STATUS.LOADING;

  const renderMessage = renderWhenTrueOtherwise(
    () => <FormattedMessage id="addToBag.buttonAddedLabel" defaultMessage="Added" />,
    () => <FormattedMessage id="addToBag.addToBag" defaultMessage="Add to bag" />
  );

  const renderLoader = renderWhenTrue(() => (
    <LoadingOverlay variant={LOADING_OVERLAY_VARIANT.BLACK} data-testid={ADD_TO_BAG_LOADING_TEST_ID} />
  ));

  const handleOnAddToBagClick = () => {
    onClick(selectedQuantity);
    setSelectedQuantity(1);
  };

  return (
    <OuterContainer isVariant={isVariant}>
      <QuantitySelect value={selectedQuantity} onChange={(quantity) => setSelectedQuantity(quantity)} options={options} />
      <InnerContainer onClick={handleOnAddToBagClick} data-testid={ADD_TO_BAG_TEST_ID} disabled={inventoryLevel === 0}>
        <Text added={isAddedToBag}>{renderMessage(isAddedToBag)}</Text>

        <Price>{formatStorePrice(price)}</Price>

        {renderLoader(isLoading)}
      </InnerContainer>
    </OuterContainer>
  );
};
